module.exports = __webpack_public_path__ + "da4684dab9445fef091f9164956f9828.png";


//////////////////
// WEBPACK FOOTER
// ./demo/img/Spotin_TM_Logo_Off-White_Big_RGB.png
// module id = 290
// module chunks = 0